<template>
  <div class="content">
    <ColumnTitle title="Openings"></ColumnTitle>
    <div class="ad">
      <p class="subtitle">Postdoc positions are immediately available</p>
      <p>We accept highly motivated postdocs to join the group and work on (but not limited to) the following projects:
      </p>
      <p>
        1) Batteries
      </p>
      <p>
        2) Catalysis
      </p>
      <p>3) Nanomaterials and nanostructures</p>

      <p>4) Emerging techniques for energy storage and production</p>
      <p>
        Please click the <a href="https://www.cailiaoren.com/zp_793.html">link</a> here
        or send an email to <a href="mailto:weichen1@ustc.edu.cn">weichen1@ustc.edu.cn</a> for details.
      </p>
    </div>
    <div class="ad">
      <p class="subtitle">Openings to graduate and undergraduate students, exchange and visiting scholars (long-term available)
      </p>
      <p>The Chen research group has capability to hire up to 3 Ph.D. students and up to 3 Master students every year.
      </p>
      <p>We welcome creative undergraduate students, exchange and visiting scholars to join our group.
      </p>
      <p>Please send an email to <a href="mailto:weichen1@ustc.edu.cn">weichen1@ustc.edu.cn</a> for details.</p>
    </div>
  </div>
</template>

<script>
import ColumnTitle from "@/components/ColumnTitle";

export default {
  name: "Contact",
  components: {ColumnTitle}
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}

.subtitle{
  color: dodgerblue;
  font-size: 20px;
}

a {
  color: dodgerblue;
}
.ad{
  margin-bottom: 32px;
}
</style>